function publicationCard(item) {
  return m('article.dc-publication-preview.dc-card', [m('span.dc-badge.dc-badge--slate', item.typeLabel), m('h3', m('a', {
    href: item.url
  }, item.title)), m('p', item.excerpt), m('footer', [m('span', item.author), m('span', `${item.readingTime} мин · 💬 ${item.comments}`)])]);
}
export default function Publications(_ref) {
  let {
    items = []
  } = _ref;
  if (!items.length) return null;
  return m('section.dc-section.dc-section--tight', m('div.dc-container', [m('header.dc-section-head', [m('div', [m('h2', 'Свежие материалы'), m('p', 'Статьи и руководства с примерами и обсуждением')]), m('a.dc-link', {
    href: '/articles'
  }, 'Все материалы →')]), m('div.dc-publication-preview__grid', items.map(publicationCard))]));
}
flarum.reg.add('devconnect-portal', 'forum/components/Publications', Publications);